import React from "react";

const IcoFolderPlus = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
    <line x1="12" y1="11" x2="12" y2="17"/><line x1="9" y1="14" x2="15" y2="14"/>
  </svg>
);

const IcoFolderUp = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
    <polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/>
  </svg>
);

const IcoCompress = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="4 14 10 14 10 20"/>
    <polyline points="20 10 14 10 14 4"/>
    <line x1="10" y1="14" x2="3" y2="21"/>
    <line x1="21" y1="3" x2="14" y2="10"/>
  </svg>
);

const IcoResize = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2"/>
    <path d="M9 3v18M3 9h18"/>
    <polyline points="15 9 19 9 19 13"/>
    <line x1="14" y1="10" x2="19" y2="5"/>
  </svg>
);

const IcoCompressPick = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="4 14 10 14 10 20"/>
    <line x1="10" y1="14" x2="3" y2="21"/>
    <polyline points="9 3 4 3 4 8"/>
    <path d="M20 21l-5-5m0 0V20m0-4h4"/>
    <circle cx="17" cy="8" r="4"/>
    <polyline points="15 8 17 10 20 6" strokeWidth="1.8"/>
  </svg>
);

const IcoUpload = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    <polyline points="17 8 12 3 7 8"/>
    <line x1="12" y1="3" x2="12" y2="15"/>
  </svg>
);

const IcoDownload = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
    <polyline points="7 10 12 15 17 10"/>
    <line x1="12" y1="15" x2="12" y2="3"/>
  </svg>
);

export default function ActionBar({
  role, path,
  onCreate, onUploadImage, onUploadFolder,
  onSearch, onCompressAll, onResize5MB, onCompressSelected, onDownload,
}) {
  return (
    <div className="action-bar">
      <div className="search-wrap">
        <svg className="search-ico" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" strokeWidth="2.5" strokeLinecap="round">
          <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
        <input
          type="text"
          placeholder="Tìm kiếm..."
          className="search-box"
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>

      <div className="ab-sep" />

      {role === "admin" && (
        <>
          <button className="icon-btn" onClick={onCreate} title="Tạo thư mục">
            <IcoFolderPlus /> Tạo thư mục
          </button>
          <button className="icon-btn" onClick={onUploadFolder} title="Upload thư mục">
            <IcoFolderUp /> Upload thư mục
          </button>
          <button className="icon-btn icon-btn-orange" onClick={onCompressAll} title={path ? "Nén tất cả ảnh trong thư mục này và thư mục con về ≤1MB" : "Nén tất cả ảnh toàn hệ thống về ≤1MB"}>
            <IcoCompress /> {path ? "Nén tất cả" : "Nén toàn bộ"}
          </button>
          <button className="icon-btn" onClick={onResize5MB} title={path ? "Resize tất cả ảnh trong thư mục này về ≤5MB" : "Resize tất cả ảnh toàn hệ thống về ≤5MB"}>
            <IcoResize /> Resize 5MB
          </button>
          <button className="icon-btn" onClick={onCompressSelected} title="Nén ảnh chọn lọc">
            <IcoCompressPick /> Nén chọn lọc
          </button>
          <div className="ab-sep" />
        </>
      )}

      <button className="icon-btn icon-btn-primary" onClick={onUploadImage} title="Upload file">
        <IcoUpload /> Upload file
      </button>

      {path && (
        <button className="icon-btn icon-btn-success" onClick={onDownload} title="Tải về">
          <IcoDownload /> Tải về
        </button>
      )}
    </div>
  );
}
